import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from "reactstrap";
import Header from './header';
import FollowUpIndicators from './indicators';
import FollowUpBeneficiaries from './beneficiaries';
import FollowupFinancial from './financial';
import FollowUpNarrativeReport from './narrative-report';
import FollowupSubprojectParentPresenter from "../../../presenters/screens/followup-parent-subproject.presenter";
import { IFollowupSubproject } from "@interfaces/screens/followup-subproject.interface";
import { AEATabs, AEATab } from "@/components/";
import { Utilities, Enums } from "@utils";
import { useParams } from "react-router-dom";

interface params {
    screen: string;
}

const FollowupSubPr: React.FC<any> = () => {
    const params: params = useParams();
    const [projectData, setProjectData] = useState(null);
    const [dataColumns, setDataColumns] = useState(null);
    const [auxData, setAuxData] = useState(null);
    const [auxScreen, setAuxScreen] = useState(null);
    const [activeTab, setActiveTab] = useState<number>(0);

    const [financialActData, setFinancialActData] = useState<any>([]);
    const [indicatorsActData, setIndicatorsActData] = useState<any>([]);
    const [beneficiariesActData, setBeneficiariesActData] = useState<any>([]);

    const view: IFollowupSubproject = {
        state: {
            projectData,
            setProjectData,
            setDataColumns,
        },
    };

	const presenter = new FollowupSubprojectParentPresenter(view);

    useEffect(() => {
        if(!!indicatorsActData.length || !!financialActData.length || !!beneficiariesActData.length) {
            setTimeout(() => {
                console.log('indicatorsActData', indicatorsActData)
                console.log('beneficiariesActData', beneficiariesActData)
                console.log('financialActData', financialActData)
                
                Utilities.showConfirmation('Procedemos a cumplimentar la información pendiente, por favor hacer clic en "Confirmar"', 'Información').then( async (response) => {
                    if(response){
                        Utilities.showLoading('Estamos trabajando en la información', 'Cargando')
                        presenter.fixMissedActIndicatorsData(indicatorsActData)
                            .then(() => presenter.fixMissedActFinancialData(financialActData))
                            .then(() => presenter.fixMissedActBeneficiariesData(beneficiariesActData))
                            .then(() => {window.location.reload()})
                    }
                });
            }, 8000)
        }
    }, [indicatorsActData, financialActData, beneficiariesActData]);


    useEffect(() => {
        if(!!presenter.currentLang) {
            presenter.initialize();
        }
        return () => {(presenter.clear())}
    }, [presenter.currentLang]);

    useEffect(() => {
        if(!!presenter.followupData && !!presenter.formMasters) presenter.getData();
    }, [presenter.followupData, presenter.formMasters]);

    useEffect(() => {
        if(!!projectData && !!presenter.formMasters && !Array.isArray(presenter.params) && presenter.currentUser?.userGroups?.length){
            let auxValue: boolean = presenter.getTotalPermissions(projectData);
            setAuxScreen(auxValue ? params.screen: Enums.FollowupState.view)
        }
    }, [projectData, presenter.formMasters, presenter?.currentUser?.userGroups, presenter.params]);

    useEffect(() => {
        if(projectData && dataColumns && presenter.subProjectDimensions?.length && !!auxScreen && presenter.followupLabels?.values?.length && (!auxData || (activeTab >= 0))){
            setAuxData (        
                <Container fluid>
                       <Row><Header data={projectData} followupLabels={presenter.followupLabels}/></Row>
                    <Row>
                        <Col>
                            <AEATabs defaultTab={0} idTour="IndicatorsTourStep3">
                                <AEATab key={0} title={presenter.followupLabels.get("stepIndicators")} onChangeTab={() => { setActiveTab(0) }} >
                                    <FollowUpIndicators projectData={projectData} screen={auxScreen} activeTab={activeTab} setIndicatorsActData={setIndicatorsActData}/>
                                </AEATab> 
                                <AEATab key={1} title={presenter.followupLabels.get("stepBeneficiaries")} onChangeTab={() => { setActiveTab(1) }} >
                                    <FollowUpBeneficiaries screen={auxScreen} projectData={projectData} activeTab={activeTab} setBeneficiariesActData={setBeneficiariesActData}/>                                
                                </AEATab>
                                <AEATab key={2} title={presenter.followupLabels.get("stepFinancial")} onChangeTab={() => { setActiveTab(2) }} >
                                    <FollowupFinancial screen={auxScreen} projectData={projectData} activeTab={activeTab} setFinancialActData={setFinancialActData}/>                                
                                </AEATab>
                                <AEATab key={3} title={presenter.followupLabels.get("stepNarrativeReport")} onChangeTab={() => { setActiveTab(3) }} >
                                    <FollowUpNarrativeReport projectData={projectData} screen={auxScreen} activeTab={activeTab} />
                                </AEATab>
                            </AEATabs>
                        </Col>
                    </Row>  
                            
                </Container>
            )
        }
    }, [projectData, dataColumns, auxScreen, presenter.subProjectDimensions, presenter.followupLabels, activeTab]);

    return (
        <>
            {auxData && auxData}
        </>
    )
}

export default FollowupSubPr;